import { STORED_HISTORY_FLOOR } from '@/auth/stored';

const closeHandlers: Array<() => void> = [];

export const registerCloseHandler = (handler: () => void): (() => void) => {
  closeHandlers.push(handler);

  return () => {
    closeHandlers.splice(closeHandlers.indexOf(handler), 1);
  };
};

export const hasOpenOverlay = (): boolean => closeHandlers.length > 0;

export const closeTopOverlay = () => {
  closeHandlers.at(-1)?.();
};

const getHistoryIndex = (): number | undefined => window.history.state?.idx;

export const isFirstHistoryEntry = (): boolean => !getHistoryIndex();

export const getCurrentUrl = (): string => {
  const { pathname, search, hash } = window.location;

  return `${pathname}${search}${hash}`;
};

const getHistoryFloor = (): number =>
  Number(sessionStorage.getItem(STORED_HISTORY_FLOOR) ?? 0);

const setHistoryFloor = (floor: number) => {
  sessionStorage.setItem(STORED_HISTORY_FLOOR, String(floor));
};

export const resetHistoryFloor = () => {
  window.history.replaceState({ ...window.history.state, idx: 0 }, '');
  setHistoryFloor(0);
};

export const moveHistoryFloorBelowCurrentPage = () => {
  setHistoryFloor(Math.max((getHistoryIndex() ?? 0) - 1, 0));
};

export const isOnHistoryFloor = (): boolean =>
  (getHistoryIndex() ?? 0) <= getHistoryFloor();

export const runAfterBackIsCancelled = (callback: () => void) => {
  if (!isOnHistoryFloor()) {
    callback();
    return;
  }

  window.addEventListener('popstate', callback, { once: true });
};
